import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../redux/store';
import http from '../utils/http';
import dateHelper from '../utils/dateHelper';
import EntityAuthorization from './UserSlice';
import { HttpResponse } from '@microsoft/signalr';


export interface UserState {
    users: logerUser[];
    status: 'idle' | 'loading' | 'failed';
}

export interface logerUser {
    activateDate: string;
    createDate: string;
    deprecateDate: string;
    firstName: string;
    lastName: string;
    id: number;
    lastLoginDate: string;
    login: string;
    role: string;
    status: string;
    entityAuthorizations: Array<EntityAuthorization>;
}

const initialState: UserState = {
    users: [] = new Array(),
    status: "idle"
}

export const getAllUsersAsync = createAsyncThunk(
    "users/fetchUsers",
    async (): Promise<logerUser[] | null> => {
        try {
            const result = await http<null, logerUser[]>({
                path: `/user/allAdminUsers`,
                method: 'get',
            });
            if (result.ok && result.parsedBody) {
                for (let item of result.parsedBody) {
                    item.deprecateDate = item.deprecateDate ? item.deprecateDate : "";
                    item.activateDate = item.activateDate ? item.activateDate : "";
                    item.createDate = item.createDate ? item.createDate : "";
                    item.lastLoginDate = item.lastLoginDate ? item.lastLoginDate : "";
                }
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const getIsAdminUserManager = createAsyncThunk("users/getIsAdminUserManager",
    async (): Promise<any> => {
        try {
            const result = await http<null, boolean>({
                path: `/user/getIsAdminUserManager`,
                method: `get`,
            });

            if(result.ok) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (e) {
            return null;
        }
    });

export const getUserDataByEmail = createAsyncThunk(
    "User/getUserDataByEmail",
    async (userId: string): Promise<logerUser | null> => {
        try {
            const result = await http<string, logerUser>({
                path: `/user/getUserDataByEmail/${userId}`,
                method: 'get',
            });
            if (result.ok && result.parsedBody) {
                if (result.parsedBody.id > 0) {
                    result.parsedBody.deprecateDate = result.parsedBody.deprecateDate ? result.parsedBody.deprecateDate : "";
                    result.parsedBody.activateDate = result.parsedBody.activateDate ? result.parsedBody.activateDate : "";
                    result.parsedBody.createDate = result.parsedBody.createDate ? result.parsedBody.createDate : "";
                    result.parsedBody.lastLoginDate = result.parsedBody.lastLoginDate ? result.parsedBody.lastLoginDate : "";

                    return result.parsedBody;
                }
                else {
                    return null;
                }

            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

interface fieldValue {
    id: string;
    fieldId: string;
    value: string;
}

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        updateAttribute: {
            reducer(state: any, action: any) {
                const { id, fieldId, value } = action.payload;
                const numId = Number.parseInt(id);
                let user = state.users.find((u: any) =>
                    u.id === numId
                );

                if (user) {
                    switch (fieldId) {
                        case "activateDate":
                            user.activateDate = value;
                            break;
                        case "deprecateDate":
                            var activeDate = dateHelper.stringToDate(user.activateDate);
                            var deprecateDate = dateHelper.stringToDate(value);
                            if ((activeDate != null && deprecateDate != null) &&
                                activeDate < deprecateDate) {
                                let currentDate = new Date()
                                user.deprecateDate = value;
                                if (deprecateDate < currentDate) {
                                    user.status = "Inactive";
                                }
                                else {
                                    user.status = "Active";
                                }
                            }
                            break;
                    }
                }
            },
            prepare(payload: fieldValue) {
                return {
                    payload
                }
            }
        },
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(getAllUsersAsync.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getAllUsersAsync.fulfilled, (state: any, action: any) => {
                state.status = "idle";
                if (action.payload != null) {
                    state.users = action.payload;
                }
            })
            .addCase(getIsAdminUserManager.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getIsAdminUserManager.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            })
            .addCase(getUserDataByEmail.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getUserDataByEmail.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            });
    },

});

export const { updateAttribute } = usersSlice.actions;

export const selectUsers = (state: RootState) =>
    state.users ? state.users.users.map((user: any) => Object.assign({}, user)) : [];


export default usersSlice.reducer;





